import React from 'react';
import moment from 'moment';
import { useSelector } from 'react-redux';
import InboxEmpty from './InboxEmpty';

const InboxAnnouncementsList = ({
    onSelectItem,
    selectedId,
    loader
}) => {
  const announcementsList = useSelector(state => state.inbox?.inboxAnnouncementsList || [])

    return (
        announcementsList && announcementsList.length > 0 ?
        announcementsList.map((item, i) => {
            return (
              <div 
               className={item.id === selectedId ? 'selected_messagesUsersList' : 'messagesUsersList'}
               key={i} onClick={() => onSelectItem(item)}>
                <div className='userIcon'> <img src='/assets/Announcement.png' alt='' /> </div>
                <div className='userInfo'>
                  <div className='userInfo__timeStamp'>{
                    moment(item.announcementDate).format('MM/DD/YYYY')}</div>
                  <div className='userInfo__UserName'>{item.propertyName}
                  </div>
                  <div className='userInfo__UserDescription'>{item.title} </div>
                </div>
              </div>
            )
          })
          : !loader && <InboxEmpty message={'No announcements found.'}/>
    )
}

export default InboxAnnouncementsList;